<template>
    <div class="subPage_container">
        <MarketView :tableComponent="VolTable" webSocketUrl="wss://ws2.goya-alert.com/vol"
            webSocketMessageFormat="fetch_{tab}_vol" />
    </div>
</template>

<script>
import MarketView from './sub/MarketView.vue';
import VolTable from './sub/VolTable.vue';

export default {
    components: {
        MarketView
    },
    data() {
        return {
            VolTable
        };
    }
};
</script>